export default () => ({
  type_specialization: {
    key: null
  },
  date: new Date(),
  config: {
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    useCurrent: false,
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  configMonths: {
    format: 'MM/YYYY',
    useCurrent: false,
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/form/resources/data.js